import { CacheAction, CacheActions, CacheState, ResourceData, ResourceId, ResourceName } from './cache.types';

export const setCache = <TEntity = ResourceData>(entity: ResourceName, id: ResourceId, entityData: TEntity) => ({
  type: CacheActions.SET_CACHE,
  payload: {
    entity,
    id,
    entityData,
  },
});

export const removeCache = (entity: ResourceName) => ({
  type: CacheActions.REMOVE_CACHE,
  payload: {
    entity,
  },
});

export const cacheReducer = (state: CacheState = {}, action: CacheAction = {} as CacheAction) => {
  const { payload } = action;

  if (action.type === CacheActions.SET_CACHE) {
    return {
      ...state,
      [payload.entity]: {
        id: payload.id,
        entityData: payload.entityData,
      },
    };
  }

  if (action.type === CacheActions.REMOVE_CACHE) {
    const newState = { ...state };
    delete newState[payload.entity];
    return newState;
  }

  return state;
};
